module.exports = __webpack_public_path__ + "static/media/2015.51366231.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/about/2015.png
// module id = 596
// module chunks = 0